module.exports = __webpack_public_path__ + "static/mateusz_gorecki-bad79b77a8a03cc444a34da0cbead501.webp";